import { Capacitor } from '@capacitor/core'
import { spLogTags } from '@eventr/common'
import { Signal } from '@preact/signals-react'
import { NotificationEjson } from '../../data/Rocket'
import { chatFallBackName } from '../../state/rocketchatState/rocketchatSignals'
import { cleanRCName } from '../../utils'
import { PushNotifications } from './plugin'

export const PushTokenSignal = new Signal<string | undefined>(undefined)

export const addPushListener = () => {
    if (Capacitor.isNativePlatform()) {
        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (data: any) => {
                const ejsonString =
                    data?.notification?.data?.ejson || data?.ejson
                const notification: NotificationEjson = JSON.parse(ejsonString)
                if (notification?.rid) {
                    chatFallBackName.value = cleanRCName(
                        notification?.name ?? ''
                    )
                    setTimeout(() => {
                        window.pushPath(
                            `/rocketchat/${notification?.type}/${notification?.rid}`
                        )
                    }, 100)
                }
            }
        )
    }
}

export const loadPushToken = async () => {
    if (!Capacitor.isNativePlatform()) {
        PushTokenSignal.value = 'dummyToken'
        return
    }

    const registerNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions()

        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions()
        }

        if (permStatus.receive !== 'granted') {
            /// Why would we throw an error? the user not wanting notifications is not an error. we should probally handle it...
            // throw new Error('User denied permissions!')

            spLogTags('User denied permissions.', ['notifications'])
        }
        await PushNotifications.register()
    }

    await PushNotifications.addListener('registration', (token) => {
        spLogTags(token.value, ['push_token'])

        if (Capacitor.getPlatform() === 'android') {
            PushNotifications.createChannel({
                id: 'high_importance_channel',
                name: 'High Importance Notifications',
                importance: 4,
            })
            PushNotifications.listChannels().then((channels) => {
                console.info('Channels: ', JSON.stringify(channels))
            })
        }
        PushTokenSignal.value = token.value
        PushNotifications.removeAllDeliveredNotifications()
    })

    registerNotifications()
}
